import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";
import { EDocumentProductDataType } from "@/formTypes/EDocumentProductDataType";

export type CreditnoteProductDataType = Partial<ApiSchema["CreditnoteProduct"]["type"] & EDocumentProductDataType>;
export const CreditnoteProductApi = new GenericModelApi<"CreditnoteProduct", CreditnoteProductDataType>("CreditnoteProduct", "codigo");